import src from "IMAGE";
export default { src, width: 569, height: 598, blurWidth: 0, blurHeight: 0};
